<template>
  <component :is="route.meta.layout || 'div'" :breadcrumbs="route.meta.breadcrumb">
    <router-view />
    <logoutModal />
  </component>
</template>
<script setup>
import { computed } from 'vue';
import logoutModal from '@/layouts/common/modals/logoutModal.vue';
import { useFunctionalitiesStore } from '@/store/functionalities';
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';

const route = useRoute();
const functionalitiesStore = useFunctionalitiesStore();
const { state } = storeToRefs(functionalitiesStore);

const user = computed(() => state.value.user);
</script>
